var path = '/pages/picklists/views/contacts/contacts-details.tpl.html';
var html = "<div class=\"col-md-12\">\n    <contact model=\"vm.contact\"\n             manager=\"vm.manager\"\n             on-save=\"vm.create(model)\"\n             on-update=\"vm.refresh()\"\n             back-route=\"vm.backRoute\"\n             on-archive=\"vm.archive(rsvp)\"\n             on-restore=\"vm.restore(rsvp)\"\n             on-delete=\"vm.delete(rsvp)\">\n    </contact>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/picklists/views/contacts/contacts-details.tpl.html
// module id = 2299
// module chunks = 1